export default import.meta.ROLLDOWN_FILE_URL_SlHWUZn$yNWlWh_Qo6Vt3w